// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles-module__spinner___Jspyz","spin":"styles-module__spin___q9vsC","fadeIn":"styles-module__fadeIn___nNFlp"};